import { render, staticRenderFns } from "./djgjb.vue?vue&type=template&id=814f4754&scoped=true&"
import script from "./djgjb.vue?vue&type=script&lang=js&"
export * from "./djgjb.vue?vue&type=script&lang=js&"
import style0 from "./djgjb.vue?vue&type=style&index=0&id=814f4754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814f4754",
  null
  
)

export default component.exports